(function () {
    'use strict';

    class EquipmentExplorerLeafletCtrl {
        constructor($q, $scope, swifRouteService, dataService, swifCartoLeafletService, $rootScope) {
            this.$scope = $scope;
            this.showLeaflet = false;
            this.route = swifRouteService;
            this.data = dataService;
            this.$q = $q;
            this.swifCartoLeafletService = swifCartoLeafletService;
            $rootScope.$on('onClickCurrentItemToOpenPopupMap', this.onClickCurrentItemToOpenPopupMap.bind(this) );
        }
        $onInit() {
            if (!this.type) {
                this.type = this.collection.contentType;
            }
            if (!this.filter) {
                this.filter = this.collection.currentFilter;
            }
            var $ctrl = this;
            this.route.check({resources: ['leaflet']}).then(function () {
                $ctrl.showLeaflet = true;
            });
            this.$scope.$watch('$ctrl.collection.currentFilter', function (newV) {
                $ctrl.filter = newV;
            }, true);
            this.$scope.$watch('$ctrl.collection.lastUpdateDateTime', function (newV) {
                $ctrl.updateMarkers();
            });
        }
        $onChanges(changesObj) {
            this.updateMarkers();
        }
        onClickCurrentItemToOpenPopupMap(event, data) {
            var $ctrl = this;
            let marker = $ctrl.markerBySiteId[data.id];
            if (marker) {
                $ctrl.map.setView(marker.getLatLng(), 18);
                marker.openPopup();
            }
        }
        _onMapInitialized(map) {
            this.map = map;
            this.updateMarkers();
            var height = $('.swif-explorer-left').height();
            $(map._container).height(height);
            map.invalidateSize(true);
        }
        updateMarkers(){
            var $ctrl = this;
            $ctrl.markerBySiteId = {};
            var service = $ctrl.swifCartoLeafletService;
            if (!this.showLeaflet || !(this.type && this.filter)) {
                return;
            }

            function getMarker(equipment) {
                var icon = service.getIconFromSite(equipment);
                var marker = service.getMarkerFromPoint(equipment.geo_point, {icon: icon});
                var $scope = $ctrl.$scope.$new();
                $scope.collection = $ctrl.collection;
                // var linkLabel = "Voir l'équipement";
                var footer = `<a class="btn btn-link"
                    ng-click="collection.setCurrent(proxy.id)">
                </a>`;
                var html = service.getPanelHTML(equipment, $scope, {footer: footer});
                marker.bindPopup(html);
                return marker;
            }

            service.removeLayerFromMap($ctrl.layer, $ctrl.map);

            var promises = [];
            var geoPointBySiteId = {};
            var markers = [];
            $ctrl.collection.items.forEach(function (equipment) {
                if (equipment.site_id) {
                    // we check for each equipment if his site is geolocated
                    promises.push($ctrl.data.get('patrimoine_site', equipment.site_id[0], {}));
                }
            });
            this.$q.all(promises).then(function(sites) {
                sites.forEach(function (site) {
                    if (site.geo_point) {
                        geoPointBySiteId[site.id] = site.geo_point;
                    }
                });
                $ctrl.collection.items.forEach(function (equipment) {
                    if (!equipment.geo_point && equipment.site_id) {
                        equipment.geo_point = geoPointBySiteId[equipment.site_id[0]];
                    }
                    if (equipment.geo_point) {
                        var marker = getMarker(equipment);
                        if (marker) {
                            markers.push(marker);
                            $ctrl.markerBySiteId[equipment.id] = marker;
                        }
                    }
                });
                if ($ctrl.map && markers.length > 0) {
                    var layer = L.featureGroup(markers);
                    $ctrl.layer = L.markerClusterGroup();
                    $ctrl.layer.options.spiderfyOnMaxZoom = false;
                    $ctrl.layer.options.disableClusteringAtZoom= 20;
                    $ctrl.layer.addLayer(layer);
                    $ctrl.layer.addTo($ctrl.map);
                    $ctrl.map.fitBounds($ctrl.layer.getBounds());
                }
                if (markers.length === 0) {
                    // when we don't have any markers, we set the view on the default geolocation
                    service.setDefaultCenterView($ctrl.map);
                }
            });

        }
    }
    EquipmentExplorerLeafletCtrl.$inject = ['$q', '$scope', 'swifRouteService', 'dataService', 'swifCartoLeafletService', '$rootScope'];


    angular.module('swif.carto')

    .component('equipmentExplorerLeaflet', {
        template: `<div ng-if="$ctrl.showLeaflet" class="widemap">
            <swif-leaflet on-map-initialized="$ctrl._onMapInitialized(map)">
            </swif-leaflet>
        </div>`,
        controller: EquipmentExplorerLeafletCtrl,
        bindings: {
            collection: '<'
        }
    });


})();
